import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { useRedirect } from 'hooks';
import { useCurrentUser } from 'contexts';

const CloseButton = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  background-color: #ff4d4f;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  opacity: 0;
  transition: all 0.2s;
  z-index: 1001;

  &:hover {
    background-color: #d9363e;
    transform: scale(1.1);
  }
`;

const FloatButton = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  cursor: pointer;
  height: 48px;
  background-color: #0aa263;
  border-radius: 24px;
  padding: 0 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  transition: all 0.3s;
  gap: 8px;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);

    ${CloseButton} {
      opacity: 1;
      top: -8px;
      right: -8px;
    }
  }

  @media (max-width: 768px) {
    width: 56px;
    height: 56px;
    padding: 0;
    border-radius: 50%;

    span {
      display: none;
    }
  }
`;

const SupportTicketFloat = () => {
  const intl = useIntl();
  const { id } = useCurrentUser();
  const { redirectTo } = useRedirect();
  const [isVisible, setIsVisible] = React.useState(true);

  const handleClick = () => {
    // Navigate strictly to chat with support account ID 150696
    if (id) {
      redirectTo(`/chat?senderId=${id}&receiverId=150696`);
    } else {
      redirectTo('/chat?receiverId=150696');
    }
  };

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <FloatButton
      onClick={handleClick}
      title={intl.formatMessage({
        id: 'support.tooltip',
        defaultMessage: 'Support',
      })}
    >
      <CloseButton onClick={handleClose}>✕</CloseButton>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C6.477 2 2 6.477 2 12C2 13.849 2.487 15.589 3.354 17.108L2 22L7.098 20.732C8.527 21.554 10.203 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>
        {intl.formatMessage({ id: 'support.title', defaultMessage: 'Support' })}
      </span>
    </FloatButton>
  );
};

export default SupportTicketFloat;
